import { FC, InputHTMLAttributes, useRef, ReactNode, MouseEvent } from 'react'
import { CheckboxContainer, Checkbox } from './styles'
import { IoMdCheckmark } from 'react-icons/io'
import { useErrors } from 'src/context/errors';

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  withBg?: boolean;
  variation?: 'medium' | 'small' | 'thin';
  isIncorrect?: boolean;
  errorCode?: string;
}

const StandardCheckbox: FC<CheckboxProps> = ({ label, checked, withBg, variation, isIncorrect, errorCode = '', ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const { hasError } = useErrors()
  
  isIncorrect = hasError(errorCode) || isIncorrect

  const onCheckboxClick = (event: MouseEvent<HTMLDivElement>) => {
    if(!!inputRef && !!inputRef.current) {
      event.stopPropagation()
      inputRef.current.click()
    }
  }

  return (
    <CheckboxContainer 
      onClick={onCheckboxClick} 
      withBg={!!withBg} 
      variation={variation ?? 'medium'} 
      checked={!!checked}
      className="tlie__standard_checkbox_container"
      isIncorrect={isIncorrect}
      data-error-code={errorCode}
    >
      <input {...rest} ref={inputRef} type="checkbox" checked={checked} />
      <Checkbox
        checked={!!checked}
        variation={variation ?? 'medium'}
        className="tlie__standard_checkbox_check"
      >
        <IoMdCheckmark />
      </Checkbox>
      <span>{label}</span>
    </CheckboxContainer>
  )
}

export default StandardCheckbox